import { useEffect, useRef, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { App } from "../../3D/tema4/app";
import { MainMenu } from "../HomeMenu/MainMenu";
import ObserverEmitter, { EVENTS } from "../../emitter/Observer";
import { LoadingGiff } from "../../components/common/LoadingGiff";
import { AlertDeviceLandscape } from "../../components/helpers/AlertDeviceLandscape";
import { LoadingSceneGiff } from "../../components/common/LoadingSceneGiff";


export const Home4 = () => {
	const [menuVisible, setMenuVisible] = useState(true);
	const containerRef = useRef(null);
	const location = useLocation();
	useEffect(() => {
		if (!containerRef.current.iscreated) {
			containerRef.current.iscreated = true;
			const container = containerRef.current;
			const app = new App(container);
			app.onResized();
		}

		// para ocultar el UI del menu cuando cargen actividades
		// eslint-disable-next-line

		ObserverEmitter.on(EVENTS.loadingCompleteScene, () => {
			setMenuVisible(false);
			ObserverEmitter.emit(EVENTS.hiddenMenusAnimations);
		});
		ObserverEmitter.on(EVENTS.init_introduction, () => {
			setMenuVisible(false);
			ObserverEmitter.emit(EVENTS.hiddenMenusAnimations);
		});
		// ----------------------------------------

		ObserverEmitter.on(EVENTS.init_mainMenu, () => {
			setMenuVisible(true);
			ObserverEmitter.emit(EVENTS.showMenuAnimations);
		});
	}, []);

	useEffect(() => {
		if (["/home4", "/home4/",].includes(location.pathname) && containerRef.current.iscreated) {
			ObserverEmitter.emit(EVENTS.back_to_main)
			ObserverEmitter.emit(EVENTS.showMenuAnimations)
		}
	}, [location])
	return (
		<div className="fixed top-0 w-full h-full z-0 bg-[#E5E5E5] flex ">
			<LoadingGiff></LoadingGiff>
			<LoadingSceneGiff></LoadingSceneGiff>
			<AlertDeviceLandscape></AlertDeviceLandscape>
			<div
				ref={containerRef}
				id="container"
				className={`cursor-grab ${menuVisible ? "w-100-212 md:w-100-470 " : "w-full"} h-full bg-[#E5E5E5]`}
			></div>
			<Outlet />
			<MainMenu></MainMenu>
		</div>
	)
}